import useGetInternalWidgetConfig from '@src/hooks/api/queries/useGetInternalWidgetConfig';
import { generateMqttClient } from '@src/pages/_loader/initMqttClient.loader';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import { MqttClient } from 'mqtt/*';
import React, { useEffect } from 'react';
import DeviceDataTable from '../DeviceDataTable';
import QueryKeys from '@src/constants/queryKeys';
import { trackerSx } from '../sxStyles/Datatable/deviceTableList';

export default function TrackerList() {
  const [mqttClient, setMqttClient] = React.useState<MqttClient>();
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const startClient = async () => {
      const client = await generateMqttClient();
      setMqttClient(client);
    };
    startClient();
    return () => {
      mqttClient?.end();
    };
  }, []);

  const { data: widgetConfig } =
    useGetInternalWidgetConfig<WidgetTypeDeviceList>(
      `trackerList`,
      {},
      {
        queryKeys: [QueryKeys.trackers],
      },
    );

  return (
    <div>
      <DeviceDataTable
        id='trackers'
        hideFooter
        additionalClassnames='detail-data-table'
        devices={widgetConfig?.devices || []}
        dataPoints={widgetConfig?.dataPoints || []}
        pointConfigRefs={widgetConfig?.pointConfigRefs || []}
        mqttClient={mqttClient}
        sx={trackerSx.detailDataTable}
      />
    </div>
  );
}
